import ApiClient from "./ApiClient";

export const getTournament = ({ id }) => ApiClient.get(`/tournaments/${id}`);
